import { Tag } from '@cian/components';
import * as React from 'react';

import { EHeatingType } from '../../../../json_query';
import { IHeatingTypesTag } from '../../../state/tags/definitions/heating';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHeatingTypesTagItemProps {
  tag: IHeatingTypesTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const heatingTypeMap = {
  [EHeatingType.Furnace]: 'Печь',
  [EHeatingType.Fireplace]: 'Камин',
  [EHeatingType.None]: 'Без отопления',
  [EHeatingType.Gas]: 'Центральное газовое',
  [EHeatingType.Coal]: 'Угольное отопление',
  [EHeatingType.Electric]: 'Электрическое',
  [EHeatingType.AutonomousGas]: 'Автономное газовое',
  [EHeatingType.Diesel]: 'Дизельное',
  [EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
};

export const HeatingTypesTagItem = ({ withNewTag, onDeleteClick, tag }: IHeatingTypesTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {heatingTypeMap[tag.value]}
    </TagComponent>
  );
};
